import React, { useState } from 'react';
import { ArrowLeft, Upload, Check, ChevronRight, MapPin, Shield, Zap, Building, FileText, Camera } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
export function CreateListingPage() {
  const [step, setStep] = useState(1);
  const totalSteps = 7;
  return <div className="min-h-screen bg-[#f5f5f7] font-sans text-[#1f2933] flex flex-col" data-id="element-3608">
      {/* Header */}
      <header className="bg-white border-b border-gray-300 py-4 px-6" data-id="element-3609">
        <div className="max-w-4xl mx-auto flex items-center justify-between" data-id="element-3610">
          <Link to="/" className="flex items-center gap-2" data-id="element-3611">
            <div className="w-8 h-8 bg-[#1f2933] rounded-sm" data-id="element-3612"></div>
            <span className="font-bold text-xl tracking-tight" data-id="element-3613">
              Citiplots.com
            </span>
          </Link>
          <div className="font-bold text-lg" data-id="element-3614">Create New Listing</div>
          <Link to="/dashboard/seller" className="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900" data-id="element-3615">
            <ArrowLeft className="w-4 h-4" data-id="element-3616" /> Exit
          </Link>
        </div>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-12" data-id="element-3617">
        {/* Progress Bar */}
        <div className="mb-12" data-id="element-3618">
          <div className="flex justify-between mb-2 text-sm font-mono text-gray-500" data-id="element-3619">
            <span data-id="element-3620">
              Step {step} of {totalSteps}
            </span>
            <span data-id="element-3621">{Math.round(step / totalSteps * 100)}% Complete</span>
          </div>
          <div className="h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-3622">
            <div className="h-full bg-[#1f2933] transition-all duration-300" style={{
            width: `${step / totalSteps * 100}%`
          }} data-id="element-3623"></div>
          </div>
        </div>

        <div className="bg-white border border-gray-300 p-8 md:p-12 shadow-sm" data-id="element-3624">
          {/* Step 1: Basic Details */}
          {step === 1 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3625">
              <div data-id="element-3626">
                <h1 className="text-2xl font-bold mb-2" data-id="element-3627">Basic Plot Details</h1>
                <p className="text-gray-500" data-id="element-3628">
                  Start with the core information about your land parcel.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3629">
                <div className="space-y-2" data-id="element-3630">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3631">
                    Listing Title
                  </label>
                  <input type="text" placeholder="e.g. 2000 Sqft Plot in Baner" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3632" />
                </div>
                <div className="space-y-2" data-id="element-3633">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3634">
                    Price (₹)
                  </label>
                  <input type="text" placeholder="e.g. 45,00,000" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3635" />
                </div>
                <div className="space-y-2" data-id="element-3636">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3637">
                    Plot Area (Sq. Ft)
                  </label>
                  <input type="number" placeholder="e.g. 2400" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3638" />
                </div>
                <div className="space-y-2" data-id="element-3639">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3640">
                    Listing Type
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3641">
                    <option data-id="element-3642">Sell</option>
                    <option data-id="element-3643">Rent / Lease</option>
                  </select>
                </div>
              </div>
            </div>}

          {/* Step 2: Location & Measurements */}
          {step === 2 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3644">
              <div data-id="element-3645">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3646">
                  <MapPin className="w-6 h-6" data-id="element-3647" /> Location & Measurements
                </h1>
                <p className="text-gray-500" data-id="element-3648">
                  Precise location helps buyers find your plot easily.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3649">
                <div className="space-y-2 md:col-span-2" data-id="element-3650">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3651">
                    Full Address
                  </label>
                  <textarea placeholder="Enter full address with landmarks..." className="w-full p-3 border border-gray-300 bg-gray-50 h-24 focus:outline-none focus:border-[#1f2933]" data-id="element-3652"></textarea>
                </div>
                <div className="space-y-2" data-id="element-3653">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3654">
                    Survey / Gat No.
                  </label>
                  <input type="text" placeholder="e.g. 45/2/A" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3655" />
                </div>
                <div className="space-y-2" data-id="element-3656">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3657">
                    PIN Code
                  </label>
                  <input type="text" placeholder="e.g. 411057" className="w-full p-3 border border-gray-300 bg-gray-50 focus:outline-none focus:border-[#1f2933]" data-id="element-3658" />
                </div>
                <div className="space-y-2" data-id="element-3659">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3660">
                    Dimensions (L x W ft)
                  </label>
                  <div className="flex gap-2" data-id="element-3661">
                    <input type="number" placeholder="Length" className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3662" />
                    <span className="self-center" data-id="element-3663">x</span>
                    <input type="number" placeholder="Width" className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3664" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-3665">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3666">
                    Boundary Wall
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3667">
                    <option data-id="element-3668">Present (Complete)</option>
                    <option data-id="element-3669">Partial</option>
                    <option data-id="element-3670">Fencing Only</option>
                    <option data-id="element-3671">None</option>
                  </select>
                </div>
              </div>
            </div>}

          {/* Step 3: Legal & Title */}
          {step === 3 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3672">
              <div data-id="element-3673">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3674">
                  <Shield className="w-6 h-6" data-id="element-3675" /> Legal & Title
                </h1>
                <p className="text-gray-500" data-id="element-3676">
                  Clear title details increase buyer confidence significantly.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3677">
                <div className="space-y-2" data-id="element-3678">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3679">
                    Ownership Type
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3680">
                    <option data-id="element-3681">Freehold</option>
                    <option data-id="element-3682">Leasehold</option>
                    <option data-id="element-3683">Co-operative Society</option>
                    <option data-id="element-3684">Power of Attorney (GPA)</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-3685">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3686">
                    Seller Type
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3687">
                    <option data-id="element-3688">Individual Owner</option>
                    <option data-id="element-3689">Developer / Builder</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-3690">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3691">
                    Any Existing Loan?
                  </label>
                  <div className="flex gap-4 mt-2" data-id="element-3692">
                    <label className="flex items-center gap-2" data-id="element-3693">
                      <input type="radio" name="loan" className="accent-[#1f2933]" data-id="element-3694" />{' '}
                      Yes
                    </label>
                    <label className="flex items-center gap-2" data-id="element-3695">
                      <input type="radio" name="loan" className="accent-[#1f2933]" defaultChecked data-id="element-3696" />{' '}
                      No
                    </label>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-3697">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3698">
                    Litigation Status
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3699">
                    <option data-id="element-3700">No Litigation (Clear)</option>
                    <option data-id="element-3701">Dispute Resolved</option>
                    <option data-id="element-3702">Case Pending</option>
                  </select>
                </div>
              </div>
            </div>}

          {/* Step 4: Attributes & Utilities */}
          {step === 4 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3703">
              <div data-id="element-3704">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3705">
                  <Zap className="w-6 h-6" data-id="element-3706" /> Infrastructure & Utilities
                </h1>
                <p className="text-gray-500" data-id="element-3707">
                  What facilities are available on or near the plot?
                </p>
              </div>

              <div className="space-y-6" data-id="element-3708">
                <div data-id="element-3709">
                  <label className="block text-sm font-bold text-gray-700 mb-3" data-id="element-3710">
                    Road Access
                  </label>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3711">
                    <div className="space-y-2" data-id="element-3712">
                      <span className="text-xs text-gray-500" data-id="element-3713">Road Type</span>
                      <select className="w-full p-2 border border-gray-300 bg-gray-50" data-id="element-3714">
                        <option data-id="element-3715">Tar / Asphalt</option>
                        <option data-id="element-3716">Concrete</option>
                        <option data-id="element-3717">WBM / Mud</option>
                      </select>
                    </div>
                    <div className="space-y-2" data-id="element-3718">
                      <span className="text-xs text-gray-500" data-id="element-3719">
                        Road Width (ft)
                      </span>
                      <input type="number" className="w-full p-2 border border-gray-300 bg-gray-50" placeholder="e.g. 40" data-id="element-3720" />
                    </div>
                  </div>
                </div>

                <div data-id="element-3721">
                  <label className="block text-sm font-bold text-gray-700 mb-3" data-id="element-3722">
                    Available Utilities
                  </label>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-3723">
                    {['Electricity', 'Municipal Water', 'Borewell', 'Sewage Line', 'Gas Pipeline', 'Street Lights'].map(item => <label key={item} className="flex items-center gap-2 p-3 border border-gray-200 cursor-pointer hover:bg-gray-50" data-id="element-3724">
                        <input type="checkbox" className="accent-[#1f2933]" data-id="element-3725" />
                        <span className="text-sm" data-id="element-3726">{item}</span>
                      </label>)}
                  </div>
                </div>
              </div>
            </div>}

          {/* Step 5: Zoning & Development */}
          {step === 5 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3727">
              <div data-id="element-3728">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3729">
                  <Building className="w-6 h-6" data-id="element-3730" /> Zoning & Development
                </h1>
                <p className="text-gray-500" data-id="element-3731">
                  Define what can be built on this land.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3732">
                <div className="space-y-2" data-id="element-3733">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3734">
                    Current Land Use
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3735">
                    <option data-id="element-3736">Residential</option>
                    <option data-id="element-3737">Commercial</option>
                    <option data-id="element-3738">Agricultural</option>
                    <option data-id="element-3739">Industrial</option>
                    <option data-id="element-3740">Mixed Use</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-3741">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3742">
                    Zone Type
                  </label>
                  <input type="text" placeholder="e.g. R-1, R-2" className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3743" />
                </div>
                <div className="space-y-2" data-id="element-3744">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3745">
                    FSI / FAR Allowed
                  </label>
                  <input type="text" placeholder="e.g. 1.5" className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3746" />
                </div>
                <div className="space-y-2" data-id="element-3747">
                  <label className="block text-sm font-bold text-gray-700" data-id="element-3748">
                    NA Conversion Status
                  </label>
                  <select className="w-full p-3 border border-gray-300 bg-gray-50" data-id="element-3749">
                    <option data-id="element-3750">NA Order Received</option>
                    <option data-id="element-3751">In Process</option>
                    <option data-id="element-3752">Not Applied</option>
                    <option data-id="element-3753">Not Applicable (Gaothan)</option>
                  </select>
                </div>
              </div>
            </div>}

          {/* Step 6: Media & Documents */}
          {step === 6 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3754">
              <div data-id="element-3755">
                <h1 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-3756">
                  <Camera className="w-6 h-6" data-id="element-3757" /> Media & Documents
                </h1>
                <p className="text-gray-500" data-id="element-3758">
                  Visuals and proof documents attract serious buyers.
                </p>
              </div>

              <div className="space-y-6" data-id="element-3759">
                <div className="border border-dashed border-gray-300 p-8 bg-gray-50 text-center" data-id="element-3760">
                  <Upload className="w-8 h-8 mx-auto text-gray-400 mb-2" data-id="element-3761" />
                  <h3 className="font-bold text-sm" data-id="element-3762">Upload Plot Photos</h3>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-3763">
                    Drag & drop or click to browse (Max 10 images)
                  </p>
                </div>

                <div data-id="element-3764">
                  <h3 className="font-bold text-sm mb-3" data-id="element-3765">Required Documents</h3>
                  <div className="space-y-3" data-id="element-3766">
                    {['7/12 Extract or Sale Deed', 'NA Order Copy', 'Latest Tax Receipt'].map((doc, i) => <div key={i} className="flex items-center justify-between p-3 border border-gray-200 bg-white" data-id="element-3767">
                        <span className="text-sm" data-id="element-3768">{doc}</span>
                        <button className="text-xs font-bold text-blue-600 border border-blue-200 px-3 py-1 rounded hover:bg-blue-50" data-id="element-3769">
                          Upload
                        </button>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>}

          {/* Step 7: Preview */}
          {step === 7 && <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4" data-id="element-3770">
              <div data-id="element-3771">
                <h1 className="text-2xl font-bold mb-2" data-id="element-3772">Review & Publish</h1>
                <p className="text-gray-500" data-id="element-3773">
                  Double check all details before going live.
                </p>
              </div>

              <div className="border border-gray-300 p-6 bg-gray-50 space-y-6" data-id="element-3774">
                <div className="flex justify-between border-b border-gray-200 pb-4" data-id="element-3775">
                  <div data-id="element-3776">
                    <h3 className="font-bold text-lg" data-id="element-3777">
                      2000 Sqft Plot in Baner
                    </h3>
                    <p className="text-gray-500" data-id="element-3778">Pune, Maharashtra</p>
                  </div>
                  <div className="text-right" data-id="element-3779">
                    <div className="font-bold text-lg" data-id="element-3780">₹ 45,00,000</div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-3781">
                  <div data-id="element-3782">
                    <span className="text-gray-500 block" data-id="element-3783">Area</span>
                    <span className="font-bold" data-id="element-3784">2,400 Sq. Ft</span>
                  </div>
                  <div data-id="element-3785">
                    <span className="text-gray-500 block" data-id="element-3786">Zoning</span>
                    <span className="font-bold" data-id="element-3787">Residential (R-1)</span>
                  </div>
                  <div data-id="element-3788">
                    <span className="text-gray-500 block" data-id="element-3789">Ownership</span>
                    <span className="font-bold" data-id="element-3790">Freehold</span>
                  </div>
                  <div data-id="element-3791">
                    <span className="text-gray-500 block" data-id="element-3792">Documents</span>
                    <span className="font-bold text-green-600" data-id="element-3793">3 Uploaded</span>
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-3794">
                <button className="flex-1 py-3 bg-[#1f2933] text-white font-bold hover:bg-gray-800" data-id="element-3795">
                  Publish Listing
                </button>
                <button className="flex-1 py-3 border border-gray-300 font-bold hover:bg-gray-50" data-id="element-3796">
                  Save Draft
                </button>
              </div>
            </div>}

          {/* Navigation Buttons */}
          {step < 7 && <div className="flex justify-between mt-12 pt-6 border-t border-gray-200" data-id="element-3797">
              <button onClick={() => setStep(Math.max(1, step - 1))} disabled={step === 1} className={`px-6 py-3 font-bold text-sm ${step === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-3798">
                Back
              </button>
              <button onClick={() => setStep(Math.min(7, step + 1))} className="flex items-center gap-2 px-8 py-3 bg-[#1f2933] text-white font-bold text-sm hover:bg-gray-800" data-id="element-3799">
                Continue <ChevronRight className="w-4 h-4" data-id="element-3800" />
              </button>
            </div>}
        </div>
      </main>

      <Footer data-id="element-3801" />
    </div>;
}